import { PageType } from "../../../constants/types.constants";
import { EndPageDetailsEntity } from "../entities/end-page-details.entity";

interface Params {
  id: number;
  imageName: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;
}

export class EndPageDetailsModel {
  id: number;
  imageName: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;

  constructor(params: Params) {
    this.id = params.id;
    this.imageName = params.imageName;
    this.description = params.description;
    this.type = params.type;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.imageUrl = params.imageUrl;
  }

  toEntity(): EndPageDetailsEntity {
    return {
      id: this.id,
      imageName: this.imageName,
      description: this.description,
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      imageUrl: this.imageUrl,
    };
  }
}
